import { render, staticRenderFns } from "./filters.component.vue?vue&type=template&id=13a78a08"
import script from "./filters.component.vue?vue&type=script&lang=js"
export * from "./filters.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports